import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app/app';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from 'libs/webkua-lib/src/lib/msal-utils';

msalInstance
  .initialize()
  .then(() => {
    console.log('MSAL Initialization Successful');
  })
  .catch((error) => {
    console.error('MSAL Initialization Error:', error);
  });

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
  <MsalProvider instance={msalInstance}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </MsalProvider>
);